/// <amd-module name="Feed/Connect/Redux/ConnectToFeed/ConnectToFeedReducers" />
import produce from "immer";

import { ConnectToFeedActions, ConnectToFeedActionTypes } from "./ConnectToFeedActions";
import { IConnectToFeedState } from "./ConnectToFeedContracts";

export const connectToFeedReducer = produce(
    (draft: IConnectToFeedState, action: ConnectToFeedActions) => {
        switch (action.type) {
            case ConnectToFeedActionTypes.ToolsInitialized:
                draft.tools = action.payload;
                break;
            case ConnectToFeedActionTypes.ToolSelected:
                draft.tool = action.payload;
                break;
            case ConnectToFeedActionTypes.GetTools:
                const tool = action.payload;
                if (tool) {
                    draft.tool = tool;
                    draft.showGetTools = true;
                } else {
                    draft.showGetTools = false;
                }
                break;
            case ConnectToFeedActionTypes.DismissFirstTimeMessage:
                draft.dismissedTools.push(action.payload);
                break;
            case ConnectToFeedActionTypes.InitializeMessageDismissedTools:
                draft.dismissedTools = action.payload;
                break;
        }
    },
    { tool: undefined, tools: [], dismissedTools: [] }
);
